import React from 'react';
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  ToggleSwitchController,
  SelectController,
  RangeController,
  ChoiceBoxController,
  SimpleColorPickerController,
} from '../../../controllers/Base';

import { getOptionsThemes } from '../../../utils/controllersUtils/themeColors';

const StyleControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  selectedColumn,
}) => (
  <>
    <ControllersGroup 
      title="Estilos"
      id="styles"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.PalletsControl === 'custom' ? data?.index?.length : 0}
    >
      <ToggleSwitchController
        label="Habilitar área"
        handle={handle}
        kWord="AreaControl"
        configValue={config?.AreaControl?.checked}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <RangeController
        label="Opacidade da área"
        handle={handle}
        kWord="AreaControl"
        configValue={config?.AreaControl?.opacity}
        min={0}
        max={1}
        step={0.1}
        precision={1}
        fullWidth
        disabled={!config?.AreaControl?.checked}
      />
      <ToggleSwitchController
        label="Exibir pontos"
        handle={handle}
        kWord="EnablePoints"
        configValue={config?.EnablePointsControl?.checked}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <RangeController
        label="Tamanho dos pontos"
        handle={handle}
        kWord="EnablePoints"
        configValue={config?.EnablePointsControl?.pointsSize}
        min={1}
        max={20}
        fullWidth
        disabled={!config?.EnablePointsControl?.checked}
      />
      <RangeController
        label="Contorno dos pontos"
        handle={handle}
        kWord="EnablePointsBorder"
        configValue={config?.EnablePointsControl?.border}
        min={1}
        max={20}
        fullWidth
        disabled={!config?.EnablePointsControl?.checked}
      />
      <ChoiceBoxController
        label="Cor dos pontos"
        handle={handle}
        kWord="PointsColorControl2"
        options={[
          { value: 'brighter', label: 'Clara', id: 'brighter' },
          { value: 'darker', label: 'Escura', id: 'darker' },
          { value: 'custom', label: 'Customizada', id: 'custom' },
        ]}
        configValue={config?.PointsColorControl?.modifiers?.[0]?.[0] || 'custom'}
        fullWidth
        disabled={!config?.EnablePointsControl?.checked}
      />
      {typeof config?.PointsColorControl !== 'string' && (
        <RangeController
          label="Opacidade dos pontos"
          handle={handle}
          kWord="PointsOpacityControl"
          configValue={config?.PointsColorControl?.modifiers?.[0]?.[1] || '1'}
          min={0}
          max={2}
          step={0.1}
          precision={1}
          fullWidth
          disabled={!config?.EnablePointsControl?.checked}
        />
      )}
      {typeof config?.PointsColorControl === 'string' && (
        <SimpleColorPickerController
          label="Cor customizada"
          handle={handle}
          kWord="PointsColorControlColorPicker"
          configValue={config?.PointsColorControl}
          orientation="row"
          fullWidth
          disabled={!config?.EnablePointsControl?.checked}
        />
      )}
      <SelectController
        label="Formato da linha"
        handle={handle}
        kWord="LinesFormatControl"
        options={[
          { label: 'Linear', value: 'linear', id: 'linear' },
          { label: 'Interpolação 1', value: 'cardinal', id: 'cardinal' },
          { label: 'Interpolação 2', value: 'natural', id: 'natural' },
          { label: 'Ajuste suave', value: 'basis', id: 'basis' },
          { label: 'Degrau central', value: 'step', id: 'stet' },
          { label: 'Degrau anterior', value: 'stepBefore', id: 'stepBefore' },
          { label: 'Degrau posterior', value: 'stepAfter', id: 'stepAfter' },
        ]}
        configValue={config?.LinesFormatControl}
        fullWidth
      />
      <RangeController
        label="Espessura da linha"
        handle={handle}
        kWord="LineWidth"
        configValue={config?.LineWidth}
        min={0}
        max={20}
        fullWidth
      />
      <ChoiceBoxController
        label="Paleta de cores"
        handle={handle}
        kWord="PalletsControl"
        options={selectedColumn ? [
          { label: 'Padrão', value: 'default', id: 'default' },
          { label: 'Degradê', value: 'gradient', id: 'gradient' },
          { label: 'Customizada', value: 'custom', id: 'custom' },
        ] : [
          { label: 'Padrão', value: 'default', id: 'default' },
          { label: 'Customizada', value: 'custom', id: 'custom' },
        ]}
        configValue={config?.PalletsControl}
        fullWidth
      />
      {config?.PalletsControl === 'default' && (
        <SelectController
          label="Tema"
          handle={handle}
          kWord="ColorTheme"
          options={getOptionsThemes()}
          configValue={config?.ColorTheme?.scheme}
          fullWidth
        />
      )}
      {selectedColumn && config?.PalletsControl === 'gradient' && (
        <>
          <SimpleColorPickerController
            label="Cor inicial"
            handle={handle}
            kWord="GradientFirstColor"
            configValue={config?.GradientPickerControl?.color1 || '#4711B2'}
            orientation="row"
          />
          <SimpleColorPickerController
            label="Cor final"
            handle={handle}
            kWord="GradientSecondColor"
            configValue={config?.GradientPickerControl?.color2 || '#FF9626'}
            orientation="row"
          />
        </>
      )}
      {config?.PalletsControl === 'custom' &&
      (!selectedColumn ? data?.columns?.map((col, i) => {
        if (col === 'Totais') return null;
        return (
          <SimpleColorPickerController
            dataColorTarget={col.toString()}
            key={`${col}_i${i}`}
            label={col}
            handle={handle}
            kWord="Colors"
            configValue={config?.Colors[col]}
            orientation="row"
            fullWidth
          />
      )}) : (
        data?.index?.map((col, i) => {
          if (col === 'Totais') return null;
          return (
            <SimpleColorPickerController
              dataColorTarget={col.toString()}
              key={`${col}_i${i}`}
              label={col}
              handle={handle}
              kWord="Colors"
              configValue={config?.Colors[col]}
              orientation="row"
              fullWidth
            />
          )
        })
      ))}
    </ControllersGroup>
  </>
);

StyleControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedColumn: PropTypes.objectOf(PropTypes.any),
};

StyleControllers.defaultProps = {
  config: undefined,
  data: undefined,
  handle: () => {},
  extend: '',
  setExtend: () => {},
  selectedColumn: undefined,
};

export default StyleControllers;
